import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-heating-plan',
  templateUrl: './heating-plan.component.html',
  styleUrls: ['./heating-plan.component.scss'],
})
export class HeatingPlanComponent {
  @ViewChild('content', { static: true }) el!: ElementRef<HTMLImageElement>;
  headers = [
    '1P',
    '1S',
    '2P',
    '2S',
    '3P',
    '3S',
    '4P',
    '4S',
    '5P',
    '5S',
    '6P',
    '6S',
    'SLP',
    'SLS',
  ];
  subheaders = [
    'VLSFO - Antwerp',
    'VLSFO - Antwerp',
    'VLSFO - Rotterdam',
    'VLSFO - Rotterdam',
    'VLSFO - Antwerp',
    'VLSFO - Antwerp',
    'VLSFO - Antwerp',
    'VLSFO - Antwerp',
    'VLSFO - Rotterdam',
    'VLSFO - Rotterdam',
    'VLSFO - Antwerp',
    'VLSFO - Antwerp',
    'Empty',
    'Empty',
  ];
  tableData = [
    {
      date: '02-Jan-24',
      bunkerData: [
        { value: 39.5, heating: 'ON' },
        { value: 39.6, heating: 'OFF' },
        { value: 40.0, heating: 'OFF' },
        { value: 40.0, heating: '' },
        { value: 40.1, heating: 'OFF' },
        { value: 39.8, heating: '' },
        { value: 39.5, heating: 'ON' },
        { value: 39.4, heating: '' },
        { value: 39.8, heating: 'OFF' },
        { value: 39.8, heating: '' },
        { value: 39.6, heating: 'OFF' },
        { value: 39.7, heating: 'ON' },
        { value: 0.0, heating: '' },
        { value: 0.0, heating: 'ON' },
      ],
      vgCargoTemp: '40.0',
      weather: {
        airTemp: '27 °C',
        seaTemp: '28 °C',
        windSpeed: '6.28 KTS',
      },
      bunkerConsp: {
        heatingBoiler: '6.6 MT',
        circulationBunker: '75 MT',
        totalBunker: '1 MT',
        boilerLoad: ' ',
      },
      heatingHours: '1',
    },
    {
      date: '03-Jan-24',
      bunkerData: [
        { value: 39.5, heating: '' },
        { value: 39.6, heating: 'OFF' },
        { value: 40.0, heating: 'ON' },
        { value: 40.0, heating: '' },
        { value: 40.1, heating: 'ON' },
        { value: 39.8, heating: 'OFF' },
        { value: 39.5, heating: '' },
        { value: 39.4, heating: '' },
        { value: 39.8, heating: 'ON' },
        { value: 39.8, heating: '' },
        { value: 39.6, heating: 'OFF' },
        { value: 39.7, heating: '' },
        { value: 0.0, heating: '' },
        { value: 0.0, heating: 'ON' },
      ],
      vgCargoTemp: '40.0',
      weather: {
        airTemp: '40.0 °C',
        seaTemp: '40.0 °C',
        windSpeed: '27 KTS',
      },
      bunkerConsp: {
        eatingBoiler: '6.6 MT',
        circulationBunker: '75 MT',
        totalBunker: '1 MT',
        boilerLoad: ' ',
      },
      heatingHours: '1',
    },
    {
      date: '02-Jan-24',
      bunkerData: [
        { value: 39.5, heating: 'ON' },
        { value: 39.6, heating: '' },
        { value: 40.0, heating: 'ON' },
        { value: 40.0, heating: '' },
        { value: 40.1, heating: 'OFF' },
        { value: 39.8, heating: '' },
        { value: 39.5, heating: 'ON' },
        { value: 39.4, heating: '' },
        { value: 39.8, heating: '' },
        { value: 39.8, heating: 'OFF' },
        { value: 39.6, heating: '' },
        { value: 39.7, heating: 'ON' },
        { value: 0.0, heating: '' },
        { value: 0.0, heating: 'ON' },
      ],
      vgCargoTemp: '40.0',
      weather: {
        airTemp: '27 °C',
        seaTemp: '28 °C',
        windSpeed: '6.28 KTS',
      },
      bunkerConsp: {
        heatingBoiler: '6.6 MT',
        circulationBunker: '75 MT',
        totalBunker: '1 MT',
        boilerLoad: ' ',
      },
      heatingHours: '1',
    },
    {
      date: '03-Jan-24',
      bunkerData: [
        { value: 39.5, heating: '' },
        { value: 39.6, heating: '' },
        { value: 40.0, heating: 'ON' },
        { value: 40.0, heating: '' },
        { value: 40.1, heating: 'ON' },
        { value: 39.8, heating: '' },
        { value: 39.5, heating: 'OFF' },
        { value: 39.4, heating: '' },
        { value: 39.8, heating: 'ON' },
        { value: 39.8, heating: '' },
        { value: 39.6, heating: 'OFF' },
        { value: 39.7, heating: '' },
        { value: 0.0, heating: '' },
        { value: 0.0, heating: 'ON' },
      ],
      vgCargoTemp: '40.0',
      weather: {
        airTemp: '40.0 °C',
        seaTemp: '40.0 °C',
        windSpeed: '27 KTS',
      },
      bunkerConsp: {
        eatingBoiler: '6.6 MT',
        circulationBunker: '75 MT',
        totalBunker: '1 MT',
        boilerLoad: ' ',
      },
      heatingHours: '1',
    },
  ];
 
}
